import LabelWithInput from "@components/input/LabelWithInput";
import styled from "@emotion/styled";
import { useFormContext } from "react-hook-form";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "4rem",
});

const TextContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",

  ".max": {
    color: theme.color.light_gray,
    fontSize: "1.2rem",
    alignSelf: "flex-end",
  },
}));

const TextArea = styled.textarea(({ theme }) => ({
  fontFamily: "Pretendard ,Sans-serif",
  width: "100%",
  height: "13.8rem",
  padding: "1rem",
  fontSize: "1.6rem",
  lineHeight: "2rem",
  border: `1px solid ${theme.color.light_gray}`,
  resize: "none",
}));

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
}));
const Description = styled.div(({ theme }) => ({
  color: theme.color.gray,
  lineHeight: "12px",
  fontSize: "1.2rem",
}));

const HelpText = styled.span(({ theme }) => ({
  color: theme.color.gray,
  lineHeight: "1.2rem",
  fontSize: "1.2rem",
  paddingTop: "2rem",
}));

const ProductDescription = ({ descriptionRef }: { descriptionRef?: any }) => {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();

  const description_ko = watch("description_ko");
  const description_en = watch("description_en");
  const lang = window.localStorage.getItem("language");

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue("description_ko", e.target.value);
  };

  const handleChangeEn = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue("description_en", e.target.value);
  };

  return (
    <Container ref={descriptionRef}>
      <TextContainer>
        <LabelWithInput label="상품설명 (국문)" required>
          {errors.description_ko && (
            <ErrorMessage>
              {errors.description_ko.message?.toString()}
            </ErrorMessage>
          )}

          <TextArea
            name="description_ko"
            onChange={handleChange}
            maxLength={2000}
            value={description_ko}
            placeholder={
              "소재, 스타일, 색상, 사이즈 등 구매자가 알 수 있도록 상품에 대해 자세히 설명해주세요."
            }
          />
        </LabelWithInput>

        <span className="max">
          {description_ko?.length}/2000 {"자"}
        </span>
      </TextContainer>

      <TextContainer>
        <LabelWithInput label="상품설명 (영문)">
          <TextArea
            name="description_en"
            onChange={handleChangeEn}
            maxLength={2000}
            value={description_en}
            placeholder={"상품설명을 영문으로 작성해주세요."}
          />
        </LabelWithInput>
        {lang === "ko" && (
          <Description>
            번역된 버전에서는 영문으로 표시되며, 영문 설명이 없는 경우 국문으로
            표시됩니다.
          </Description>
        )}

        <span className="max">
          {description_en?.length}/2000 {"자"}
        </span>
      </TextContainer>

      {lang === "en" && (
        <HelpText>
          번역된 버전에서는 영문으로 표시되며, 영문 설명이 없는 경우 국문으로
          표시됩니다.
        </HelpText>
      )}
    </Container>
  );
};

export default ProductDescription;
